// @flow
import React from 'react';
import classnames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import { getIconName, getTitle } from './ContentCollectionUtility';
import ContentCollectionProvider from './ContentCollectionProvider';
import styles from './ContentCollection.less';

/**
 * A button to start content collection from the global nav
 */
const ContentCollection = () => {
  const isNonComponentTablet = !featureIsEnabled('components_header');

  const titleText = getTitle();
  const symbol = classnames('ui_icon', getIconName());

  return (
    <div
      className={classnames(styles.container, {
        [styles.nonComponentContainer]: isNonComponentTablet,
      })}
      title={titleText}
    >
      <ContentCollectionProvider>
        {({ ref, onClick }) => (
          <div ref={ref} onClick={onClick} className={styles.icon} title={titleText}>
            <span className={symbol}>
              <span className={styles.label}>{titleText}</span>
            </span>
          </div>
        )}
      </ContentCollectionProvider>
    </div>
  );
};

export default ContentCollection;
